'use client';

import { useTranslations } from 'next-intl';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ContainerTypeListing } from './container-type-listing';
import { SubContainerTypeListing } from './sub-container-type-listing';

export function ContainerTypesPageContent() {
  const t = useTranslations('containerTypes');

  return (
    <Tabs defaultValue='container-types'>
      <TabsList>
        <TabsTrigger value='container-types'>
          {t('tabContainerTypes')}
        </TabsTrigger>
        <TabsTrigger value='sub-container-types'>
          {t('tabSubContainerTypes')}
        </TabsTrigger>
      </TabsList>
      <TabsContent value='container-types'>
        <ContainerTypeListing />
      </TabsContent>
      <TabsContent value='sub-container-types'>
        <SubContainerTypeListing />
      </TabsContent>
    </Tabs>
  );
}
